import '@/assets/styles/views/solver/mobile-direction.scss';
import { useFeatureFlag } from 'configcat-react';
import { CONFIGCAT_KEYS } from '@/constants/configcat-keys.ts';
import { useMemo } from 'react';

const MobileDirection = () => {
	const { value: mobileDirectionQrCodeUrl, loading: isLoadingMobileDirectionQrCodeUrl } = useFeatureFlag(CONFIGCAT_KEYS.MOBILE_DIRECTION_QR_CODE_URL, '');

	const isReadyQrCode = useMemo(() => !isLoadingMobileDirectionQrCodeUrl && !!mobileDirectionQrCodeUrl?.replace(' ', '')?.length, [isLoadingMobileDirectionQrCodeUrl, mobileDirectionQrCodeUrl]);

	return (
		<div className="mobile-direction-container">
			<h1 className="title">Hemen Doping Hafıza Bire Bir Uzman Uygulamasını İndir!</h1>

			<div className="direction-step-container">
				<div className="direction-step">
					<img src="/assets/solver-send-question.png" />
					<div className="direction-step-info">
						<h6 className="title">Sorunu Seç, Çözümünü Gönder</h6>
						<p className="description">Branşına uygun soruyu havuzdan seç, çözümünü kaydedip paylaş.</p>
					</div>
				</div>
				<div className="direction-step">
					<img src="/assets/solver-save-question.png" />
					<div className="direction-step-info">
						<h6 className="title">Çözümünü Kaydet</h6>
						<p className="description">İster kamera ile, ister beyaz tahta üzerinden soruyu videolu yanıtla.</p>
					</div>
				</div>
				<div className="direction-step">
					<img src="/assets/solver-price-question.png" />
					<div className="direction-step-info">
						<h6 className="title">Kazancın Hesabına Yansısın</h6>
						<p className="description">Çözümünü gönder, değerlendirme sonrası kazancın hesabına yansısın.</p>
					</div>
				</div>
			</div>

			<div className="qr-wrapper">
				{isReadyQrCode && (
					<img
						src={mobileDirectionQrCodeUrl}
						alt="QR Code for Doping Hafıza Bire Bir Uzman Uygulaması"
					/>
				)}
				<div className="qr-wrapper-detail">
					<p>
						<b>Çözücü uygulaması en verimli şekilde mobil cihazlardan kullanılır!</b> Çözücü'yü tarayıncan kullanmak yerine, mobil cihazına indirerek çok daha etkili bir deneyim
						yaşayabilirsin.
					</p>
					<p>
						Yandaki <b>QR kodu</b> okutarak Doping Hafıza Birebir Uzman uygulamasını <b>indirebilirsin.</b>
					</p>
				</div>
			</div>

			<div className="marketplace-phone-qr">
				<img src="/assets/solver-marketplace-phone-qr.png" />
			</div>
		</div>
	);
};

export default MobileDirection;
